
import { connect } from 'react-redux';
import { useCallback, useRef, useEffect } from 'react';
import { Row, Col, Modal, Tooltip, Button, OverlayTrigger } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { solid, duotone } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useTranslation } from 'react-i18next';
import useMonitorAPIService from 'src/services/monitorapiservice';
import { SelectBox } from 'devextreme-react/select-box';
import React, { useState } from 'react';
import ChatService from 'src/services/chatservice';
import Toastr from "src/components/utils/toastr.js"

const transferType = [
    { id: "", name: "none" },
    { id: "group", name: "group" },
    { id: "agent", name: "agent" },
];

function TransferModal(props) {

    const { t } = useTranslation();
    const [type, setType] = useState("");
    const [userId, setUserId] = useState(null);
    const [agents, setAgents] = useState([]);
    const [groups, setGroups] = useState([]);
    const [groupId, setGroupId] = useState(null);
    const toastrRef = useRef(null);

    useEffect(() => {
        //ChatService.registerTransferError(transferError);
        return () => {
        };
    }, []);

    const { getSupervisedAgents, getSupervisedGroups } = useMonitorAPIService();

    const handleTypeChange = useCallback((value) => {
        setType(value);
        if (value === "agent") {
            getSupervisedAgents(props.token, (res) => {
                if (res?.data?.length > 0)
                    setAgents(res.data);
            });
        }

        if (value === "group") {
            getSupervisedGroups(props.token, (res) => {
                if (res?.data?.length > 0)
                    setGroups(res.data);
            });
        }
    }, [props.token, getSupervisedAgents, getSupervisedGroups]);

    const transfer = useCallback(() => {

        let user = type === "agent" ? userId : null;
        let group = type === "group" ? groupId : null;

        ChatService.transferChatSupervisor(user, group, props.chat.id, props.id, e => {
            props.toggleModal();
        });

    }, [props.toggleModal, props.chat, type, userId, groupId]);

    const transferError = message => {
        toastrRef.current.setType("error");
        toastrRef.current.setMessage(t("transfererror"));
        toastrRef.current.show();

    }

    return (
        <>
            <Modal show={props.show} onHide={props.toggleModal} size="sm">
                <Modal.Header>
                    <Modal.Title>
                        <FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} /> {t("transfer")}
                    </Modal.Title>
                    <OverlayTrigger
                        placement="left"
                        delay={{ show: 250, hide: 400 }}
                        overlay={<Tooltip style={{ position: "fixed" }}>
                            {t("close")}
                        </Tooltip>}>
                        <Button onClick={props.toggleModal} className='float-end'><FontAwesomeIcon icon={solid('xmark')} /></Button>
                    </OverlayTrigger>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col>
                            <label className="form-label fw-semibold">{t("transfertype")}</label>
                            <SelectBox
                                dataSource={transferType.map(x => { return { id: x.id, name: t(x.name) } })}
                                value={type}
                                onValueChange={handleTypeChange}
                                valueExpr="id"
                                displayExpr="name"
                                searchEnabled={true}
                                dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                            />
                        </Col>
                    </Row>
                    {
                        type === "agent" &&
                        <Row>
                            <Col>
                                <label className="form-label fw-semibold">{t("agent")}</label>
                                <SelectBox
                                    dataSource={agents.map(x => { return { id: x.userId, name: x.fullName } })}
                                    value={userId}
                                    onValueChange={setUserId}
                                    valueExpr="id"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                                />
                            </Col>
                        </Row>
                    }
                    {
                        type === "group" &&
                        <Row>
                            <Col>
                                <label className="form-label fw-semibold">{t("group")}</label>
                                <SelectBox
                                    dataSource={groups.map(x => { return { id: x.groupId, name: x.groupName } })}
                                    value={groupId}
                                    onValueChange={setGroupId}
                                    valueExpr="id"
                                    displayExpr="name"
                                    searchEnabled={true}
                                    dropDownButtonRender={() => { return (<FontAwesomeIcon icon={duotone("down")} />) }}
                                />
                            </Col>
                        </Row>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={transfer}>
                        <FontAwesomeIcon icon={duotone("arrow-right-arrow-left")} /> {t("transfer")}
                    </Button>
                </Modal.Footer>
            </Modal>
            <Toastr ref={toastrRef} />
        </>

    );
}
const mapStateToProps = (state) => {
    return {
        token: state.supervisor.token,
        id: state.supervisor.id
    };
};

export default connect(mapStateToProps, {})(TransferModal);